import { render } from "./VencidosCxc.vue?vue&type=template&id=bce155ee&scoped=true"
import script from "./VencidosCxc.vue?vue&type=script&lang=js"
export * from "./VencidosCxc.vue?vue&type=script&lang=js"

import "./VencidosCxc.vue?vue&type=style&index=0&id=bce155ee&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce155ee"]])

export default __exports__